import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FixedHeightPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: ${props => props.theme.spacing(3)};
  max-height: calc(100vh - 7rem);
  height: calc(100vh - 7rem);
  gap: ${props => props.theme.spacing(1)};
  overflow: hidden;
`;
